module.exports = __webpack_public_path__ + "static/media/paper_side.b6655564.png";